import { copyObject } from "utilities/Objects";

export default function migrate_from_v2(v2Garden: any): any {
    const gardenCopy = copyObject(v2Garden);
    gardenCopy.version = 3;
    gardenCopy.plantings = [];
    return gardenCopy;
}